<template>
  <div class="Modal_inner">
    <div class="LogRecord__modal">
      <div class="LogRecord__modal--pt">
        <p class="LogRecord__modal_thanks_tx">
          今日もMELONに来てくださって、<br class="_dsp-none--pc">ありがとうございます。<br>
          あなたの毎日が幸せでありますように。
        </p>
        <div class="LogRecord__modal_thanks_label_area">
          <div class="LogRecord__modal_thanks_label">
            <p>いつだって、<br class="_dsp-none--pc">自分だけは変えられると信じよう。</p>
          </div>
          <div class="LogRecord__modal_note _ft-rgt">
            今日のマインドフルネス
          </div>
        </div>
      </div>
    </div>
    <div class="LogRecord__modal_btn_area" @click="finishUpdate">
      <div class="LogRecord__modal_btn LogRecord__modal_btn--check ft_en _hover_pt01 _cross" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogWriteModalStep3',
  methods: {
    finishUpdate() {
      this.$emit('modalClose')
    }
  }
}
</script>
